import { ROUTES } from '@/constants/routes';
import { useMutation } from '@tanstack/react-query';
import { setLocale } from '@treyd-io/core/utils/locale';
import { signIn } from 'next-auth/react';
import { useSearchParams } from 'next/navigation';

export const useGoogleLogin = () => {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get('callbackUrl');

  return useMutation({
    mutationFn: () =>
      signIn('google', {
        callbackUrl: callbackUrl || ROUTES.home,
      }),

    onSuccess: () => {
      setLocale(navigator.language);
    },
  });
};

export default useGoogleLogin;
